// JavaScript Document
//components/configuration/PowerPicker.js
import React from 'react';
//import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
//import AppBar from '@material-ui/core/AppBar';
//import Typography from '@material-ui/core/Typography';
//import Box from '@material-ui/core/Box';
//import Card from '@material-ui/core/Card';
//import CardActions from '@material-ui/core/CardActions';
//import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
//const utils = require('../daysettings/Utils');

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 130,
  },
  gridder: {
	  padding: theme.spacing(3)
  }
}));

export default function PowerPicker(props) {
  	const classes = useStyles();
	//Inherited props
	const {times, onChange} = props;
	//form variables
  	const [onTime, setOnTime] = React.useState('00:00:00');
  	const [offTime, setOffTime] = React.useState('23:59:59');
  	//const [valid, setValid] = React.useState(true);
	//const errorMessage = 'Conflicts with existing interval';
  	//const validate = () => {
	//  	setValid(utils.control.interval.validate([onTime, offTime], intervals));
  	//};
  	const handleOnChange = (e) => {
	  	setOnTime(e.target.value);
	  	//validate();
  	};
  	const handleOffChange = (e) => {
	  	setOffTime(e.target.value);
	  	//validate();
  	};
  	const handleUpdateTimes = () => {
		//update parent if onChange provided
		if(onChange){
	  		onChange([onTime, offTime]);
  		}
	};
	//Update ui on props change
  	React.useEffect(() => {
		if(times.length === 2){
		  	//console.log('setting times from input');
		  	//console.log(times);
		  	setOnTime(times[0]);
		  	setOffTime(times[1]);
	  	}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);

  	return (
		<Grid container justifyContent="space-around" className={classes.gridder}>
    		<TextField
        		id="time-on"
        		label="On"
        		type="time"
	  			value={onTime}
        		className={classes.textField}
	  			onChange={handleOnChange}
	  			autoFocus={true}
	  			required={true}
        		InputLabelProps={{
	  				shrink: true,
        		}}
        		inputProps={{
	  				step: 300, // 5 min
        		}}
      		/>
	  		<TextField
        		id="time-off"
        		label="Off"
        		type="time"
	  			onChange={handleOffChange}
	  			value={offTime}
	  			required={true}
        		className={classes.textField}
        		InputLabelProps={{
	  				shrink: true,
        		}}
        		inputProps={{
	  				step: 300, // 5 min
        		}}
      		/>
	  		<Button variant="contained" color="primary" onClick={handleUpdateTimes}>
  				Add
	  		</Button>
	  </Grid>
  );
}
